<!--
 * @Description: description
 * @Author: chenguobiao
 * @Date: 2021-12-26 21:58:20
 * @LastEditTime: 2022-02-07 17:17:28
 * @LastEditors: chenguobiao
-->
<template>
  <div class="icon--question" @click="handleClick">
    <img src="@/render/assets/images/home/icon_question.png">
  </div>
</template>

<script>
export default {
  methods: {
    handleClick() {
      this.$emit('handleClick')
    }
  }
}
</script>

<style lang="scss" scoped>
  .icon--question {
    cursor: pointer;
    position: fixed;
    right: val(21);
    bottom: val(136);
    width: val(86);
  }
</style>